/* global __DEV__ */
/* eslint no-console: 0 */

import window from "global/window";

const PLACEHOLDER_USER_ID = '-99';
const PLACEHOLDER_ORG_ID = '-999';

function trackEvent(event_name, payload) {
  payload.event_name = event_name;
  payload.user_id = window.DATACORAL_USER_ID || PLACEHOLDER_USER_ID;
  payload.org_id = window.DATACORAL_ORG_ID || PLACEHOLDER_ORG_ID;

  log("datacoral trackUnstructEvent called with:", {data: payload});

  if (!window.datacoral) {
    log("datacoral JS tracking not enabled");
    return;
  }

  window.datacoral("trackUnstructEvent", {data: payload});
}

function log() {
  if (__DEV__) {
    console.log.apply(void 0, arguments);
  }
}

export { trackEvent };
